<template>
  <div class="roles">
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("heading.logs") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleMainBtn">
        {{ btnText }}
      </v-btn>
    </v-toolbar>

    <filter-search />
    <v-progress-linear
      color="primary"
      class="mt-2"
      indeterminate
      v-if="loading"
      rounded
      height="6"
    ></v-progress-linear>
    <v-expansion-panels class="mt-2" v-model="panel" multiple>
      <v-expansion-panel
        v-for="(key, i) in Object.keys(logs)"
        :key="i"
        class="logs__expansion-panel"
      >
        <v-expansion-panel-header class="logs__panel">{{
          key
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            class="pt-0 mx-1"
            :headers="headers"
            :items="logs[key].group_activities"
            :items-per-page="20"
            dense
            hide-default-footer
            :mobile-breakpoint="0"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.model_type }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.user ? item.user.email : "" }}</td>
                <td>
                  <v-icon small title="edit" @click="showDetails(item)">
                    mdi-eye</v-icon
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-if="!loading && Object.keys(logs).length === 0">
      <v-alert outlined color="purple">
        {{ $t("message.no_date") }}
      </v-alert>
    </div>

    <!-- pagination -->
    <div class="text-xs-center pt-2">
      <v-pagination
        v-if="Object.keys(logs).length > 0 && pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="20"
        @input="handlePagination"
      ></v-pagination>
    </div>
    <!-- pagination -->

    <v-dialog v-model="dialog" max-width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2 mb-5" primary-title>
          <slot name="heading">Activiy Detials</slot>
          <v-spacer />
          <v-btn icon>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col sm="6" md="6" lg="6"> </v-col>
            </v-row>
            <v-data-iterator
              :items="Object.keys(itemChanges)"
              :items-per-page.sync="itemsPerPage"
              hide-default-footer
            >
              <template v-slot:default="props">
                <v-row>
                  <v-col
                    v-for="(item, index) in props.items"
                    :key="index"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-card>
                      <v-card-title class="subheading font-weight-bold">{{
                        $t(`heading.${item}`)
                      }}</v-card-title>

                      <v-divider></v-divider>

                      <v-list dense>
                        <v-list-item
                          v-for="(chgKey, index) in Object.keys(
                            itemChanges[item]
                          )"
                          :key="index"
                        >
                          <v-list-item-content>{{
                            $t("labels.text_with_colon", { value: chgKey })
                          }}</v-list-item-content>
                          <v-list-item-content class="align-end">{{
                            itemChanges[item][chgKey]
                          }}</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData } from "@/helpers/apiMethods";
import FilterSearch from "./filter";
export default {
  components: {
    FilterSearch
  },
  data() {
    return {
      headers: [],
      logs: [],
      itemChanges: [],
      itemsPerPage: 2,
      dialog: false,
      expnad: true,
      panel: [],
      pagination: {},
      loading: false
    };
  },
  watch: {
    "$route.query": function() {
      this.fetchLogs();
    }
  },
  computed: {
    expanded() {
      return Array.from(Array(20).keys());
    },
    btnText() {
      const plength = this.panel.length;
      return this.$t(`button.${plength > 0 ? "collapse" : "expand"}`);
    }
  },
  created() {
    this.createTableHeaders();
    this.fetchLogs();
  },
  methods: {
    fetchLogs() {
      this.loading = true;
      let query = Object.assign({}, this.$route.query);
      IndexData({ reqName: `activities`, query })
        .then(res => {
          this.logs = res.data.log_groups;
          this.pagination = res.data.meta;
          console.log(this.logs);
          this.expandAll();
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showDetails(item) {
      console.log("item ", item);
      this.itemChanges = item.changes;
      this.dialog = true;
    },
    handlePagination(value) {
      this.$router.push({ query: { ...this.$route.query, page: value } });
      window.scrollTo({ top: 0 });
    },
    handleMainBtn() {
      this.panel.length > 0 ? this.collapseAll() : this.expandAll();
    },
    expandAll() {
      this.panel = [...Array(Object.keys(this.logs).length).keys()].map(
        (k, i) => i
      );
    },
    collapseAll() {
      this.panel = [];
    },
    createTableHeaders() {
      const headersList = ["model", "description", "email", "configs"];
      this.headers = TableHeaders(headersList);
    }
  }
};
</script>

<style lang="scss" scoped>
.logs {
  &__panel {
    min-height: 0px;
  }
  &__expansion-panel.v-expansion-panel--active {
    margin-top: 4px !important;
  }
}
</style>
